export const CREATE_SETS = 'CREATE_SETS'
export const RECEIVE_SETS = 'RECEIVE_SETS'
export const EMPTY_SETS = 'EMPTY_SETS'
export const FAILED = 'FAILED'